module.exports = __webpack_public_path__ + "static/media/ycmsml.4c4b2aa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ycmsml.png
// module id = 452
// module chunks = 0